// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__3f81Q","TemporaryMessage":"Home_TemporaryMessage__3_z9W"};